module.exports = __webpack_public_path__ + "assets/img/img92.2829d909.png";